import React from 'react';
import { Icon } from 'semantic-ui-react';
import { toast } from 'react-toastify';

interface CopyToClipboardIconProps {
  value?: string;
}

export function CopyToClipboardIcon({ value }: CopyToClipboardIconProps) {
  if (!value) return null;

  const handleClick = () => {
    navigator.clipboard.writeText(value);
    toast.success('Copied to clipboard.');
  };

  return (
    <Icon
      name="copy outline"
      style={{ fontSize: '1.0em', verticalAlign: 'text-top', marginLeft: '0.2rem', cursor: 'pointer' }}
      onClick={handleClick}
    />
  );
}
